import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ImageLogo } from '@guryou/html-components';
import { Divider, Drawer, IconButton, List, ListItem, ListItemText } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssistantIcon from '@material-ui/icons/Assistant';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import ListAltIcon from '@material-ui/icons/ListAlt';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import PageviewIcon from '@material-ui/icons/Pageview';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import logo from 'assets/img/studio-ai-logo.png';

export const aiLinks = [
  {
    id: 1,
    text: 'AI Agents',
    href: '/guryou-ai-studio',
    icon: <AssistantIcon />,
  },
  {
    id: 2,
    text: 'Preview Training Plan',
    href: '/guryou-ai-studio/preview/training-plan',
    icon: <FindInPageIcon />,
  },
  {
    id: 3,
    text: 'Preview Workout',
    href: '/guryou-ai-studio/preview/workout',
    icon: <PageviewIcon />,
  },
  {
    id: 4,
    text: 'Workout Plans',
    href: '/guryou-ai-studio/workout-plans',
    icon: <AssignmentIcon />,
  },
  {
    id: 5,
    text: 'Exercise',
    href: '/guryou-ai-studio/preview/excercise',
    icon: <DirectionsRunIcon />,
  },
  {
    id: 6,
    text: 'Exercises',
    href: '/guryou-ai-studio/exercises',
    icon: <ListAltIcon />,
  },
  {
    id: 7,
    text: 'Workouts',
    href: '/guryou-ai-studio/workouts',
    icon: <FitnessCenterIcon />,
  },
  {
    id: 8,
    text: 'Circuits',
    href: '/guryou-ai-studio/circuits',
    icon: <RotateRightIcon />,
  },
  {
    id: 9,
    text: 'Go to YouDeal',
    href: '/',
    icon: <InboxIcon />,
  },
];

const AiSidebar = ({ open, classes, handleDrawerClose }) => {
  const history = useHistory();
  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.drawerHeader}>
        <ImageLogo src={logo} />
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <List>
        {aiLinks.map(item => (
          <ListItem button key={item.id} onClick={() => history.push(item.href)}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <Divider style={{ background: '#303030' }} />
    </Drawer>
  );
};

export default AiSidebar;
